/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratorselectfunds3Inputs */

const en_settings_collaborators_invitecollaboratorselectfunds3 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratorselectfunds3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Funds`)
};

/**
* | output |
* | --- |
* | "Select Funds" |
*
* @param {Settings_Collaborators_Invitecollaboratorselectfunds3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratorselectfunds3 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratorselectfunds3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratorselectfunds3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratorselectfunds3(inputs)
});
export { settings_collaborators_invitecollaboratorselectfunds3 as "settings_collaborators_inviteCollaboratorSelectFunds" }